module.exports = ".dialogContrans {\r\n    width: ;\r\n}\r\n\r\n@media (max-width: 616px) {\r\n\r\n    .dialogContrans {\r\n        \r\n    }\r\n}"